<template>
    <div class="printOrderDetails">
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <i
                    class="el-icon-arrow-left"
                    @click="$router.go(-1)"
                ></i>
                <div class="processItem" v-for="(item,index) in processList" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== '5'"></i>
                </div>
            </div>
            <!-- 订单信息 -->
            <div class="orderMessage">
                <div class="orderMessage_title">
                    <h4>订单信息</h4>
                    <p>买家：{{modelDetail.orderBase?modelDetail.orderBase.creatorName:''}}</p>
                    <!--<i class="iconfont icon-weixin " @click="startChat(modelDetail.orderBase.creatorUuid)"></i>-->
                </div>
                <div class="orderMessage_con">
                    <p>订单编号：{{modelDetail.orderBase? modelDetail.orderBase.orderNo:''}}</p>
                    <p>创建时间：{{modelDetail.orderBase?modelDetail.orderBase.createDate:''}}</p>
                    <p v-if="modelDetail.orderBase?modelDetail.orderBase.payDate:''">付款时间：{{modelDetail.orderBase?modelDetail.orderBase.payDate:''}}</p>
                </div>
            </div>
            <!-- 模型信息 -->
            <div class="orderMessage" style="border: none">
                <div class="orderMessage_title">
                    <h4>模型信息</h4>
                </div>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="num" label="序号" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="modelName" label="模型名称" align="center">
                        <template slot-scope="scope">
                            <div class="designerImg">
                                <img :src="scope.row.modelImg" alt=""/>
                                <p>{{ scope.row.modelName }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="modelFile.name" label="模型文件名称" align="center">
                        <template slot-scope="scope">
                            <div  class="threeModel" v-for="(items,index) in scope.row.modelFile" :key="index">
                                <p @click="handPreview(items)">{{items.name}}</p>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="modelRemark"
                        label="模型描述"
                        width="400"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div class="modelRemarks">{{scope.row.modelRemark}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="实付款" align="center">
                        <template slot-scope="scope">
                            ¥{{scope.row.totalPrice}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--<div class="orderRecordButton"  v-if="type !== 'evaluate'">
                <el-button plain @click="toEvaluate">评价</el-button>
                <el-button type="primary" @click="handleBatchDownload">下载</el-button>
            </div>-->
        </div>
        <!--评价弹出框-->
        <el-dialog
            title="评价"
            :visible.sync="evaluateDialogVisible"
            width="500px">
            <div class="evaluateDialogBox">
                <div class="evaluateItem">
                    <div class="name">评价等级</div>
                    <div class="content">
                        <div class="rateItem">
                            <div class="name">描述相符</div>
                            <el-rate
                                v-model="evaluateForm.describe"
                                show-score
                                text-color="#ff9900">
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">服务态度</div>
                            <el-rate
                                v-model="evaluateForm.serve"
                                show-score
                                text-color="#ff9900">
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">物流服务</div>
                            <el-rate
                                v-model="evaluateForm.logistics"
                                show-score
                                text-color="#ff9900">
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价标签</div>
                    <div class="content">
                        <el-checkbox-group v-model="evaluateForm.tagCheckboxGroup" class="evaluateTag">
                            <el-checkbox-button v-for="tag in tagList" :label="tag.uuid" :key="tag.uuid">{{tag.name}}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价内容</div>
                    <div class="content">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 6}"
                            placeholder="请输入内容"
                            v-model="evaluateForm.content">
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="evaluateDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="evaluateSubmit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 3D预览 -->
        <three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
        ></three-d>
    </div>
</template>

<script>
    import {
        getModelOrderDetail
    } from "../../utils/interface";
    import threeD from "@/components/threeD/index";

    export default {
        name: "printOrderDetails",
        data() {
            return {
                tableData: [],
                evaluateDialogVisible: false,
                evaluateForm: {
                    describe: 0,
                    serve: 0,
                    logistics: 0,
                    tagCheckboxGroup: [],
                    content: ''
                },
                tagList: [
                    {
                        uuid: '0',
                        name: '服务好'
                    },
                    {
                        uuid: '1',
                        name: '态度好'
                    },
                    {
                        uuid: '2',
                        name: '质量好'
                    },
                    {
                        uuid: '3',
                        name: '效率高'
                    },
                    {
                        uuid: '4',
                        name: '标签标签标签标签标签标签'
                    },
                    {
                        uuid: '5',
                        name: '标签标签'
                    }
                ],
                processActive: '0',
                processList: [
                    {
                        id: '0',
                        name: '买家下单'
                    },
                    {
                        id: '1',
                        name: '订单支付'
                    },
                    {
                        id: '2',
                        name: '评价'
                    },
                    {
                        id: '3',
                        name: '完成'
                    }
                ],
                modelDetail: {},
                type: '',
                innerVisible: false,
                fileListNew: [],
            };
        },
        components: {
            threeD,
        },
        mounted(){
            this.getDetail()
        },
        methods: {
            // 获取模型订单详情
            getDetail(){
                this.type = this.$route.query.type
                getModelOrderDetail({uuid:this.$route.query.uuid}).then(res=>{
                    this.modelDetail = res
                    if(res.modelStatus == 'UN_PAY'){
                        this.processActive ='1';
                    }else if(res.modelStatus == 'UN_APPRAISE'){
                        this.processActive ='2';
                    }else if(res.modelStatus == 'FINISHED'){
                        this.processActive ='3';
                    }
                    this.tableData = []
                    this.tableData.push({
                        num: "01",
                        modelName: res.modelName,
                        modelImg: res.modelImg,
                        totalPrice: res.orderBase.totalPrice,
                        modelRemark: res.modelRemark,
                        modelFile: res.modelFile,
                    })
                })
            },
            // 点击打开评价弹出框
            toEvaluate() {
                this.evaluateForm = {
                    describe: 0,
                    serve: 0,
                    logistics: 0,
                    tagCheckboxGroup: [],
                    content: ''
                }
                this.evaluateDialogVisible = true
            },
            // 评价提交
            evaluateSubmit() {
                // if(this.evaluateForm.describe && this.evaluateForm.serve && this.evaluateForm.logistics){
                //     this.evaluateDialogVisible = false
                //     this.$message.success('评价成功')
                // } else {
                //     this.$message.warning('请选择评价等级')
                // }
            },
            // 模型下载
            handleBatchDownload() {},
            // 3D弹窗
            handPreview(index) {
                this.$refs.threeBox.threeAnimal(index);
                this.innerVisible = true;
            },
            closeDlog(index) {
                this.innerVisible = index;
            },
        },
    };
</script>

<style scoped lang="less">
    p {
        margin: 0;
    }

    i {
        font-style: normal;
    }

    .printOrderDetails {
        background: #f5f5f5;
        // 订单状态
        .detailsState {
            background: #fff;
            font-size: 14px;
            padding: 26px 32px;
            margin-bottom: 8px;

            .detailsState_one {
                display: flex;
                align-items: center;

                &:nth-of-type(1) {
                    margin-bottom: 16px;
                }

                i {
                    font-size: 18px;
                    margin-right: 5px;
                    cursor: pointer;
                }

                .detailsState_one_title {
                    font-size: 16px;
                    font-weight: 500;
                    margin-right: 8px;
                }

                .detailsState_one_time {
                    color: #1890ff;
                }
            }
        }

        // 报价流程
        .details {
            background: #fff;
            padding: 0 8px;

            .detailsProcess {
                border-bottom: 1px solid #efefef;
                display: flex;
                align-items: center;
                .processItem{
                    display: flex;
                    align-items: center;
                    &:nth-last-child(1) .typeIcon {
                        display: none;
                    }
                    // cursor: pointer;
                    // &:hover{
                    //     .process_type{
                    //         i {
                    //             background: #1890ff;
                    //             color: #fff;
                    //             border: 1px solid #1890ff;
                    //         }
                    //         p {
                    //             color: #000;
                    //         }
                    //     }
                    // }
                }
                .process_type {
                    width: 232px;
                    height: 64px;
                    // line-height: 64px;
                    display: flex;
                    align-items: center;
                    // border-bottom: 2px solid #1890ff;
                    text-align: center;
                    justify-content: center;
                    i {
                        display: inline-block;
                        width: 24px;
                        height: 24px;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        border-radius: 50%;
                        color: rgba(0, 0, 0, 0.15);
                        line-height: 27px;
                        font-size: 14px;
                        margin-right: 8px;
                    }
                    p {
                        font-size: 16px;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .typeIcon {
                    color: rgba(0, 0, 0, 0.3);
                    font-size: 18px;
                }
                .process_type2 {
                    border-bottom: 3px solid #1890ff;
                    i {
                        background: #1890ff;
                        color: #fff;
                        border: 1px solid #1890ff;
                    }
                    p {
                        color: #000;
                    }
                }
            }

            // 订单信息
            .orderMessage {
                border-bottom: 1px solid #efefef;
                margin: 0 24px;
                padding-bottom: 8px;

                .orderMessage_title {
                    height: 64px;
                    display: flex;
                    align-items: center;

                    h4 {
                        font-size: 16px;
                        font-weight: 500;
                        color: rgba(0, 0, 0, 0.85);
                        margin-right: 24px;
                    }

                    p {
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.85);
                        margin-right: 15px;
                    }

                    i {
                        color: #1890ff;
                        cursor: pointer;
                    }
                }

                .orderMessage_con {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                    margin-bottom: 16px;

                    p {
                        width: 362px;
                    }
                }

                .designerImg {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 64px;
                        height: 64px;
                        margin-right: 8px;
                    }

                    i {
                        color: #1890ff;
                    }
                }
                .modelRemarks {
                    display: -webkit-box;
                    overflow: hidden;
                    white-space: normal !important;
                    text-overflow: ellipsis;
                    word-wrap: break-word;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical
                }
                .threeModel {
                    p {
                        margin-bottom: 5px;
                        cursor: pointer;
                        color: #1890ff;
                    }
                }
            }

            .orderRecordButton {
                margin-top: 24px;
                text-align: right;
                margin-bottom: 70px;
                margin-right: 20px;
            }
        }
    }

    .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/modelOrderDetails.vue